<template>
    <div :class="wrapperClass" class="d-flex align-items-center justify-content-center">
        <div class="spinner-border" :class="spinnerClass" :style="cusotmStyles" role="status">
            <span class="sr-only"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AppPreLoader",
        props: {
            cusotmStyles: {
                type: Object,
                default: () => {}
            },
            spinnerClass: {
                type: String,
                default: ''
            },
            wrapperClass: {
                type: String,
                default: ''
            },
            
        }
    }
</script>
